<template>
  <section class="section-container" v-if="!is_supplier">
    <div class="content-wrapper">
      <div class="content-heading" v-if="worker.id">
        {{ $t('worker.edit') }}
      </div>
      <div class="content-heading" v-else>
        {{ $t('worker.add') }}
      </div>
      <div class="row">
        <div class="col-xl-4">
          <div class="card card-default">
            <div class="card-body">
              <form @submit.prevent="save" class="form-modal form-worker">

                <div class="form-group">
                  <label for="first_name">{{ $t('worker.first-name') }} *</label>
                  <input
                    :class="{'parsley-error': errors.first_name}"
                    autocomplete="off"
                    class="form-control"
                    id="first_name"
                    :placeholder="$t('worker.insert-first-name')"
                    type="text"
                    v-model="worker.first_name">
                  <ul class="parsley-errors-list filled" v-if="errors.first_name">
                    <li class="parsley-required">{{ errors.first_name[0] }}</li>
                  </ul>
                </div>

                <div class="form-group">
                  <label for="last_name">{{ $t('worker.last-name') }} *</label>
                  <input
                    :class="{'parsley-error': errors.last_name}"
                    autocomplete="off"
                    class="form-control"
                    id="last_name"
                    :placeholder="$t('worker.insert-last-name')"
                    type="text"
                    v-model="worker.last_name">
                  <ul class="parsley-errors-list filled" v-if="errors.last_name">
                    <li class="parsley-required">{{ errors.last_name[0] }}</li>
                  </ul>
                </div>

                <div class="form-group">
                  <label for="email">{{ $t('worker.email') }} *</label>
                  <input
                    :class="{'parsley-error': errors.email}"
                    autocomplete="off"
                    class="form-control"
                    id="email"
                    :placeholder="$t('worker.insert-email')"
                    type="text"
                    v-model="worker.email">
                  <ul class="parsley-errors-list filled" v-if="errors.email">
                    <li class="parsley-required">{{ errors.email[0] }}</li>
                  </ul>
                </div>

                <div class="form-group">
                  <label for="personal_code">{{ $t('worker.personal-code') }}</label>
                  <input
                    :class="{'parsley-error': errors.personal_code}"
                    autocomplete="off"
                    class="form-control"
                    id="personal_code"
                    :placeholder="$t('worker.insert-personal-code')"
                    type="text"
                    v-model="worker.personal_code">
                  <ul class="parsley-errors-list filled" v-if="errors.personal_code">
                    <li class="parsley-required">{{ errors.personal_code[0] }}</li>
                  </ul>
                </div>

                <div class="form-group">
                  <label for="personal_code">{{ $t('worker.bc-code') }}</label>
                  <input
                    :class="{'parsley-error': errors.bc_code}"
                    autocomplete="off"
                    class="form-control"
                    id="personal_code"
                    :placeholder="$t('worker.insert-bc-code')"
                    type="text"
                    v-model="worker.bc_code">
                  <ul class="parsley-errors-list filled" v-if="errors.bc_code">
                    <li class="parsley-required">{{ errors.bc_code[0] }}</li>
                  </ul>
                </div>

                <div class="form-group">
                  <label for="phone">{{ $t('worker.phone') }} *</label>
                  <input
                    :class="{'parsley-error': errors.phone}"
                    autocomplete="off"
                    class="form-control"
                    id="phone"
                    :placeholder="$t('worker.insert-phone')"
                    type="text"
                    v-model="worker.phone">
                  <ul class="parsley-errors-list filled" v-if="errors.phone">
                    <li class="parsley-required">{{ errors.phone[0] }}</li>
                  </ul>
                </div>

                <div class="form-group">
                  <label for="position">{{ $t('worker.position') }}</label>
                  <input
                    :class="{'parsley-error': errors.position}"
                    autocomplete="off"
                    class="form-control"
                    id="position"
                    :placeholder="$t('worker.insert-position')"
                    type="text"
                    v-model="worker.position">
                  <ul class="parsley-errors-list filled" v-if="errors.position">
                    <li class="parsley-required">{{ errors.position[0] }}</li>
                  </ul>
                </div>

                <div class="form-group">
                  <label>{{ $t('worker.group') }}</label>
                  <select
                    class="form-control"
                    id="group"
                    v-model="worker.group"
                  >
                    <option value="CONTRACTOR">{{ $t('worker.contractor') }}</option>
                    <option value="MASTER">{{ $t('worker.master') }}</option>
                    <option value="ADMINISTRATOR">{{ $t('worker.administrator') }}</option>
                  </select>
                </div>

                <div class="form-group">
                  <label>{{ $t('worker.groups') }}*</label>
                  <multiselect
                    v-model="warehouse_group"
                    :class="{'parsley-error': errors.warehouse_groups}"
                    :tag-placeholder="$t('worker.add-new')"
                    :placeholder="$t('worker.search')"
                    label="name"
                    track-by="name"
                    :options="warehouse_groups"
                    :multiple="true"
                    :taggable="true"
                    @tag="addGroup">
                    <template slot="noOptions">{{ $t('global.no-options') }}</template>
                  </multiselect>
                  <ul class="parsley-errors-list filled" v-if="errors.warehouse_groups">
                    <li class="parsley-required">{{ errors.warehouse_groups[0] }}</li>
                  </ul>
                </div>

                <div class="row pb-3">
                  <div class="col-md-6">
                    <div class="checkbox c-checkbox">
                      <label for="is_active">
                        <input
                          v-model="worker.is_active"
                          :class="{'parsley-error': errors.is_active}"
                          class="form-control"
                          type="checkbox"
                          id="is_active">
                        <span class="fa fa-check"></span>{{ $t('worker.active') }}
                      </label>
                    </div>
                  </div>

                  <div class="col-md-6" v-if="!this.worker.id">
                    <more/>
                  </div>

                </div>
                <buttons url="workers"/>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/api'
import Buttons from '@/components/Buttons.vue'
import message from '@/message'
import More from '@/components/More.vue'
import {objectToFormData, parseApiError} from '@/utils'
import Multiselect from 'vue-multiselect'

const getData = (id, next) => {
  if (id) {
    Promise.all([
      api.get(`/workers/${id}/`),
      api.get(`/groups/?is_active=true&page_size=100`)
    ])
      .then(([worker, groups]) => {
        let group = []
        if (worker.data.warehouse_groups) {
          worker.data.warehouse_groups.forEach(wg => {
            group.push({
              'name': wg
            })
          })
        }

        next({
          worker: worker.data,
          warehouse_group: group,
          warehouse_groups: groups.data.results
        })
      })
  } else {
    Promise.all([
      api.get(`/groups/?is_active=true&page_size=100`)
    ])
      .then(([groups]) => {
        next({
          worker: {
            first_name: '',
            last_name: '',
            email: '',
            personal_code: '',
            phone: '',
            group: 'CONTRACTOR',
            position: '',
            is_active: true
          },
          warehouse_group: [],
          warehouse_groups: groups.data.results
        })
      })
  }
}

export default {
  components: {
    buttons: Buttons,
    more: More,
    Multiselect
  },
  data () {
    return {
      worker: {},
      warehouse_group: [],
      warehouse_groups: [],
      more: null,
      errors: {}
    }
  },
  computed: {
    is_supplier () {
      return this.$store.getters.user_group === 'Supplier'
    }
  },
  mounted () {
    this.$parent.menu = 'users'
    this.$parent.submenu = 'workers'
    this.$i18n.locale = this.$store.getters.language
  },
  methods: {
    save () {
      this.errors = {}

      let tagsGroups = []
      for (let n in this.warehouse_group) {
        tagsGroups.push(this.warehouse_group[n].name)
      }

      const data = objectToFormData({
        id: this.worker.id,
        first_name: this.worker.first_name,
        last_name: this.worker.last_name,
        email: this.worker.email,
        personal_code: this.worker.personal_code,
        phone: this.worker.phone,
        group: this.worker.group,
        position: this.worker.position,
        warehouse_group: this.worker.warehouse_group,
        warehouse_groups: tagsGroups,
        is_active: this.worker.is_active,
        bc_code: this.worker.bc_code
      })

      if (this.worker.id) {
        api.patch(`/workers/${this.worker.id}/`, data)
          .then(() => {
            message.success(this.$i18n.t('worker.updated'))
            this.$router.push({name: 'workers'})
          })
          .catch(error => {
            let errors = parseApiError(error, this.$i18n)
            if (error.response && error.response.status === 400) {
              this.errors = errors
            } else {
              message.error(errors)
            }
          })
      } else {
        api.post('/workers/', data)
          .then(() => {
            message.success(this.$i18n.t('worker.added'))
            if (this.more) {
              this.worker = {
                first_name: '',
                last_name: '',
                email: '',
                personal_code: '',
                phone: '',
                position: '',
                group: 'CONTRACTOR',
                is_active: true,
                worker_groups: []
              }
              this.warehouse_group = []
              this.warehouse_groups = []
              this.$router.push({name: 'worker_add'})
            } else {
              this.$router.push({name: 'workers'})
            }
          })
          .catch(error => {
            let errors = parseApiError(error, this.$i18n)
            if (error.response && error.response.status === 400) {
              this.errors = errors
            } else {
              message.error(errors)
            }
          })
      }
    },
    addGroup (newName) {
      this.warehouse_group.push({
        name: newName
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    getData(to.params.id, data => {
      next(vm => {
        Object.assign(vm.$data, data)
      })
    })
  },
  beforeRouteUpdate (to, from, next) {
    getData(to.params.id, data => {
      Object.assign(this.$data, data)
      next()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Worker.vue